import styled from 'styled-components/macro';

export const Container = styled.main`
  align-items: center;
  display: flex;
  flex: 1;
  position: relative;
  z-index: 1;
`;
